import { useState, useEffect, useRef } from 'react'; 
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import AutoComplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import FormControl from '@mui/material/FormControl';
import { createTheme, ThemeProvider, Typography } from '@mui/material';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const theme = createTheme({
    components: {
      MuiAutocomplete: {
        styleOverrides: {
          root: {
            '& .MuiOutlinedInput-root.MuiInputBase-sizeSmall .MuiAutocomplete-input': {
              fontFamily: 'Roboto medium, Helvetica, Arial, sans-serif',
              fontSize: '14px',
              fontWeight: '500'
            },
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: {
            '&.MuiTypography-root': {
              fontFamily: 'Roboto regular, Helvetica, Arial, sans-serif',
              fontSize: '14px',
              fontWeight: '400'
            },
          },
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            fontFamily: 'Roboto medium, Helvetica, Arial, sans-serif',
            fontSize:'14px',
            fontWeight: '500'
          },
        },
      },
    },
  });


const AutoCompleteInputCopy = ({tag, values, setValues, list, width, font, showError,disableEdit,topAlignTypography=false}) => {
    // initialize ref
    const ref = useRef();
    // set width if not passed as prop
    if (width == null){
        width = '16.6vw';
    }
    // set font size if given as prop, else use default
    let style = {};
    if (font){ 
        style['fontSize'] = font; 
    }

    // handler for change event 
    const onChange = (e, value) => { 
        setValues(values => values = value); 
    }

    // function to check that two objects are equal
    const checkEqual = (value1, value2) => {
        // compare objects (keys must be in same order)        
        return  JSON.stringify(value1) === JSON.stringify(value2) ; 
    }

    // handle showing error and setting focus
    const [error, setError] = useState(); 
    useEffect(() => {
        if (showError && showError == true) { 
            // set show error
            setError(error => error = true); 
            // focus on error element 
            ref.current.focus();
        }
        else {
            setError(error => error = false); 
        }
    }, [showError]); 

    // render
    return (
        <>
        {/* material ui autocomplete component */}
        <ThemeProvider theme={theme}>
            <div className={topAlignTypography ? 'd-flex flex-column align-items-start w-100': 'd-flex gap-2 align-items-center w-100'}>
                <Typography>
                    {tag}
                </Typography>
                <FormControl fullWidth size='small'  sx={{ width: width }} >
                <AutoComplete
                    readOnly={disableEdit}
                    size='small'
                    multiple
                    id="checkboxes-tags-demo"
                    value={values}
                    options={list}
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.toString()}
                    renderOption={(props, option, { selected }) => (
                        <li {...props}>
                        <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                        />
                        {option}
                        </li>
                    )}
                    // style={{ width: width }}
                    renderInput={(params) => (
                        <TextField 
                            {...params} 
                            style={style} 
                            InputProps={{ ...params.InputProps, style: style }} 
                            InputLabelProps={{style: style}} 
                            placeholder={tag}
                        />
                    )}
                    onChange={onChange}
                    isOptionEqualToValue={checkEqual}
                />
            </FormControl>
            </div>
            </ThemeProvider>
        </>
    );
}

export default AutoCompleteInputCopy;
